<template>
  <IQOS required :title="$t('chain_settings.title')">
    <SlideToggleRow
      :value="chain.settings.menu"
      @input="(v) => changeMenuValue(v)"
      class="mt-16"
    >
      {{ $t("chain_settings.option_menu") }}
    </SlideToggleRow>
    <!-- <SlideToggleRow
      :value="chain.settings.pos_integrations"
      @input="(v) => changeValue('pos_integrations', v)"
      class="mt-16"
    >
      {{ $t("chain_settings.option_pos") }}
    </SlideToggleRow> -->
    <SlideToggleRow
      :value="chain.settings.online_payment"
      @input="(v) => changeValue('online_payment', v)"
      class="mt-16"
    >
      {{ $t("chain_settings.option_payment") }}
    </SlideToggleRow>
    <!-- <SlideToggleRow
      :value="chain.settings.integrations"
      @input="(v) => changeValue('integrations', v)"
      class="mt-16"
    >
      {{ $t("chain_settings.option_integrations") }}
    </SlideToggleRow> -->
    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{ $t("chain_settings.comment_1") }}
    </p>
    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{ $t("chain_settings.comment_2") }}
    </p>
    <!-- <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" /> -->
  
    <ChainBaseCafeModal 
      @close="copy_menu_modal = false"
      @confirm="onMenuEnableConfirmed"
      v-if="copy_menu_modal"/>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";
import BlackInput from "@/components/BlackInput.vue";

import SlideToggleRow from "@/components/SlideToggleRow.vue";

import ChainAPI from "@/api/chain";

import ChainBaseCafeModal from "@/components/chain/ChainBaseCafeModal.vue";

export default {
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
    ChainBaseCafeModal,
    SlideToggleRow,
  },
  data() {
    return {
      editing: false,

      copy_menu_modal: false,
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.editing = false;
    },
    changeValue(key, value) {
      this.$store.commit("setChainSetting", {
        key,
        value,
      });
      this.$store.dispatch("saveChain");
    },
    onMenuEnableConfirmed(cafe_id) {
      ChainAPI.centralMenusChanged(this.chain._id, true, cafe_id);
      this.changeValue("menu", true);
      this.copy_menu_modal = false;
    },
    changeMenuValue(v) {
      if (v) {
        this.copy_menu_modal = true;
        // ChainAPI.centralMenusChanged(this.chain._id, true, null);
      } else {
        this.changeValue("menu", false);
        ChainAPI.centralMenusChanged(this.chain._id, false, null);
      }
    },
    reset() {},
  },
  mounted() {
    this.reset();
  },
  computed: {
    chain() {
      return this.$store.state.selected_chain;
    },
  },
};
</script>

<style>
</style>